'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  search: {
    placeholder: 'Search'
  },
  menuToggle: {
    label: 'MENU'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: 'TEST DRIVE',
    classes: 'btn-ghost hidden-xs gold',
    link: '/en-us/free-trial'
  }, {
    text: 'LOGIN',
    classes: 'btn-ghost hidden-xs concur-blue',
    link: ''
  }],
  siteLinks: [{
    title: {
      text: 'PRODUCTS'
    },
    list: [{
      text: 'Expense products',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Expense',
        src: '/en-us/expense-management'
      }, {
        text: 'Concur Detect by AppZen',
        src: '/en-us/detect-expense-fraud'
      }, {
        text: 'Concur Drive',
        src: '/en-us/concur-drive'
      }, {
        text: 'ExpenseIt',
        src: '/receipt-management-app'
      }, {
        text: 'Budget',
        src: '/en-us/budget-management'
      }, {
        text: 'Audit Services',
        src: '/en-us/travel-expense-audit-service'
      }, {
        text: 'Concur Request',
        src: '/en-us/expense-approval-system'
      }, {
        text: 'Payment Solutions',
        src: '/en-us/payment-solutions'
      }, {
        text: 'Company Bill Statements',
        src: '/en-us/p-card-reconciliation'
      }, {
        text: 'All products',
        src: '/en-us/all-products-page#expense-products'
      }]
    }, {
      text: 'Travel products',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Travel',
        src: '/en-us/travel-booking'
      }, {
        text: 'Concur Locate',
        src: '/en-us/concur-locate'
      }, {
        text: 'Budget',
        src: '/en-us/budget-management'
      }, {
        text: 'Concur Request',
        src: '/en-us/expense-approval-system'
      }, {
        text: 'Concur TripLink',
        src: '/en-us/triplink'
      }, {
        text: 'TripLink Connected Suppliers',
        src: '/en-us/triplink-supplier-connections'
      }, {
        text: 'All products',
        src: '/en-us/all-products-page#travel-products'
      }]
    }, {
      text: 'Invoice products',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Invoice',
        src: '/en-us/invoice-management'
      }, {
        text: 'Invoice Capture',
        src: '/en-us/effortless-invoice-capture'
      }, {
        text: 'Payment Solutions',
        src: '/en-us/payment-solutions'
      }, {
        text: 'Payment Providers',
        src: '/en-us/payment-providers'
      }, {
        text: 'Purchase Request',
        src: '/en-us/purchase-request'
      }, {
        text: 'Three-Way Match',
        src: '/en-us/three-way-match'
      }, {
        text: 'All products',
        src: '/en-us/all-products-page#invoice-products'
      }]
    }, {
      text: 'Data insights',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Budget',
        src: '/en-us/budget-management'
      }, {
        text: 'Analytics',
        src: '/en-us/analytics'
      }, {
        text: 'Intelligence',
        src: '/en-us/business-intelligence'
      }, {
        text: 'Consultative Intelligence',
        src: '/en-us/travel-expense-data-analysis'
      }, {
        text: 'All products',
        src: '/en-us/all-products-page#data-insights'
      }]
    }, {
      text: 'Support offerings',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Service Administration',
        src: '/en-us/service-administration'
      }, {
        text: 'User Support Desk',
        src: '/en-us/user-support-desk'
      }, {
        text: 'Preferred Care',
        src: '/en-us/preferred-care'
      }, {
        text: 'Support info',
        src: '/en-us/support'
      }, {
        text: 'All products',
        src: '/en-us/all-products-page#support'
      }]
    }, {
      text: 'Integrations',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'SAP',
        src: '/en-us/sap-integration'
      }, {
        text: 'QuickBooks',
        src: '/en-us/quickbooks-page'
      }, {
        text: 'ADP',
        src: '/en-us/adp-integration'
      }, {
        text: 'App Center',
        src: '/en-us/app-center'
      }, {
        text: 'Concur TripLink',
        src: '/en-us/triplink'
      }, {
        text: 'NetSuite',
        src: '/en-us/netsuite-integration'
      }, {
        text: 'Platform',
        src: '/en-us/open-platform-apps'
      }, {
        text: 'Software',
        src: '/en-us/software-integration'
      }, {
        text: 'All products',
        src: '/en-us/all-products-page#integrations'
      }]
    }, {
      text: 'TMC Products',
      src: '/en-us/en-us/tmc-solutions',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Compleat',
        src: '/en-us/tmc-solutions/compleat'
      }, {
        text: 'Concur Task Manager',
        src: '/en-us/tmc-solutions/task-manager'
      }, {
        text: 'Concur Trip Approval',
        src: '/en-us/tmc-solutions/trip-approval'
      }, {
        text: 'TravPay Hotel',
        src: '/en-us/tmc-solutions/travpay'
      }, {
        text: 'Traveler Self-Service',
        src: '/en-us/tmc-solutions/traveler-self-service'
      }, {
        text: 'TMC Solutions',
        src: '/en-us/tmc-solutions'
      }, {
        text: 'All products',
        src: '/en-us/all-products-page#tmc-products'
      }]
    }, {
      text: 'All products',
      src: '/en-us/all-products-page'
    }, {
      text: 'Test Drive',
      src: '/en-us/free-trial',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'SOLUTIONS'
    },
    list: [{
      text: 'By business need',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Duty of care',
        src: '/en-us/duty-of-care'
      }, {
        text: 'Employee Experience',
        src: '/en-us/employee-engagement'
      }, {
        text: 'Fraud and compliance',
        src: '/en-us/compliance-fraud'
      }, {
        text: 'Global expansion',
        src: '/en-us/global-travel-expense-management'
      }, {
        text: 'Growth',
        src: '/en-us/growth'
      }, {
        text: 'Intelligent Spend Management',
        src: '/en-us/intelligent-spend-management'
      }, {
        text: 'Productivity',
        src: '/en-us/productivity'
      }, {
        text: 'Strategic spend management',
        src: '/en-us/strategic-spend-management'
      }, {
        text: 'Travel and Expense',
        src: '/en-us/travel-expense'
      }, {
        text: 'Visibility and control',
        src: '/en-us/visibility-and-compliance'
      }, {
        text: 'All solutions',
        src: '/en-us/solutions#by-business-need'
      }]
    }, {
      text: 'By industry',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Automotive',
        src: '/en-us/automotive '
      }, {
        text: 'Financial services',
        src: '/en-us/financial-services'
      }, {
        text: 'Healthcare',
        src: '/en-us/healthcare'
      }, {
        text: 'Higher education',
        src: '/en-us/higher-education-solutions'
      }, {
        text: 'Legal/professional services',
        src: '/en-us/professional-services'
      }, {
        text: 'Life sciences',
        src: '/en-us/life-sciences'
      }, {
        text: 'Manufacturing',
        src: '/en-us/manufacturing'
      }, {
        text: 'Non profits',
        src: '/en-us/non-profit-organizations'
      }, {
        text: 'Oil, mine, and gas',
        src: '/en-us/oil-mine-and-gas-companies'
      }, {
        text: 'Retail and restaurant',
        src: '/en-us/retail-and-restaurant'
      }, {
        text: 'Technology companies',
        src: '/en-us/technology'
      }, {
        text: 'All solutions',
        src: '/en-us/solutions#by-industry'
      }]
    }, {
      text: 'By role',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Enterprise Finance Leader',
        src: '/en-us/financial-manager-solutions'
      }, {
        text: 'Small Business Finance Leader',
        src: '/en-us/modern-finance-leaders'
      }, {
        text: 'IT Leader',
        src: '/en-us/IT-leader'
      }, {
        text: 'Travel Manager',
        src: '/en-us/business-travel-management'
      }, {
        text: 'All solutions',
        src: '/en-us/solutions#by-role'
      }]
    }, {
      text: 'For public sector',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Federal',
        src: '/en-us/federal-government-solutions'
      }, {
        text: 'Government contracting',
        src: '/en-us/government-contractor-solutions'
      }, {
        text: 'Higher education',
        src: '/en-us/higher-education-solutions'
      }, {
        text: 'Public sector compliance',
        src: '/en-us/public-sector-compliance-audit'
      }, {
        text: 'Public sector finance',
        src: '/en-us/public-sector-finance-solution'
      }, {
        text: 'Public sector HR',
        src: '/en-us/public-sector-hr-solution'
      }, {
        text: 'Public sector IT',
        src: '/en-us/public-sector-it'
      }, {
        text: 'Public sector security',
        src: '/en-us/public-sector-travel-duty-of-care'
      }, {
        text: 'State and local',
        src: '/en-us/state-local-government-solution'
      }, {
        text: 'All solutions',
        src: '/en-us/public-sector-hub'
      }]
    }, {
      text: 'For small business',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Expense',
        src: '/en-us/small-business/expense'
      }, {
        text: 'Concur Invoice',
        src: '/en-us/small-business/invoice'
      }, {
        text: 'Concur Travel',
        src: '/en-us/business-travel'
      }, {
        text: 'All solutions',
        src: '/en-us/small-business'
      }]
    }, {
      text: 'All solutions',
      src: '/en-us/solutions'
    }, {
      text: 'REQUEST PRICING',
      src: '/en-us/get-quote-form',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'ABOUT US'
    },
    list: [{
      text: 'About SAP Concur',
      src: '/en-us/about-concur'
    }, {
      text: 'Executives',
      src: '/en-us/executive-team'
    }, {
      text: 'Locations',
      src: '/en-us/contact/offices'
    }, {
      text: 'Corporate Social Responsibility',
      src: '/en-us/about/corporate-responsibility'
    }, {
      text: 'Careers',
      src: '/en-us/careers'
    }, {
      text: 'Support',
      src: '/en-us/support'
    }, {
      text: 'Reviews',
      src: '/en-us/reviews'
    }, {
      text: 'CONTACT SALES',
      src: '/en-us/contact',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'RESOURCES'
    },
    list: [{
      text: 'Newsroom',
      src: '/newsroom'
    }, {
      text: 'Resource Center',
      src: '/en-us/resource-center'
    }, {
      text: 'Events',
      src: '/en-us/events'
    }, {
      text: 'Case Studies',
      src: '/en-us/casestudy/index'
    }, {
      text: 'Partners',
      src: '/en-us/partners'
    }, {
      text: 'App Center',
      src: '/en-us/app-center'
    }, {
      text: 'Mobile Apps',
      src: '/en-us/mobile'
    }, {
      text: 'SAP Business Exchange',
      src: ''
    }, {
      text: 'Expense Demo',
      src: '/self-guided-demo-expense',
      classes: 'call-out'
    }, {
      text: 'Invoice Demo',
      src: '/self-guided-demo-invoice',
      classes: 'call-out'
    }]
  }],
  supportLinks: [{
    text: 'LOGIN',
    href: ''
  }, {
    text: 'SERVICE STATUS',
    href: ''
  }, {
    text: 'CONTACT SALES',
    href: '/en-us/contact'
  }, {
    text: 'REQUEST PRICING',
    href: '/en-us/get-quote-form'
  }, {
    text: 'SUPPORT',
    href: '/en-us/support'
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};